import { helpers } from '@vuelidate/validators';
import { ValidationRuleWithParams } from '@vuelidate/core';

export default class ServerValidationHandler {
	serverErrors: Record<string, Array<string>> = {};

	public serverError(fieldName: string): ValidationRuleWithParams {
		return helpers.withParams(
			{ type: 'serverError', serverErrors: this.serverErrors[fieldName] },
			() => !(this.serverErrors[fieldName] && this.serverErrors[fieldName].length > 0)
		);
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	public handleServerValidation(error: any): void {
		if (error.response && error.response.data && error.response.data.fieldErrorMap) {
			this.serverErrors = error.response.data.fieldErrorMap;
		}
	}

	public clearServerErrors(inputToClear: string): void {
		if (this.serverErrors[inputToClear]) {
			delete this.serverErrors[inputToClear];
		}
	}
}
